import ArrowBottom from "assets/svg/arrow-bottom.svg";
import Dots from "assets/svg/dots.svg";
import React, { FC, useEffect, useState } from "react";

import { Title } from "..";
import styles from "./styles.module.css";

type Props = {
  fullDescription: string;
  title?: string;
};
const Description: FC<Props> = ({ fullDescription, title }) => {
  const [moreDeta, setMoreDeta] = useState(false);
  useEffect(() => {
    setMoreDeta(fullDescription?.length < 500);
  }, [fullDescription]);

  return (
    <div
      className={`h-auto overflow-hidden rounded bg-white p-5 pb-0 shadow transition-all lg:shadow-md`}
      style={{
        contain: "content",
      }}
    >
      <div
        className={`${
          moreDeta ? "h-auto pb-3" : "max-h-[380px]"
        } relative overflow-hidden transition-all`}
        style={{ contain: "content" }}
      >
        {!moreDeta && (
          <div
            className="absolute contents h-full w-full overflow-hidden"
            style={{
              background:
                "linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 39%, rgba(255,255,255,0) 100%)",
            }}
          />
        )}
        <div className="flex w-full justify-between">
          <Title
            type="DOT"
            title={title + " " + "با دادبانان"}
            wrapperClass="text-blue-550 mb-5"
          />
          <Dots className="w-7 md:w-9" />
        </div>
        <div
          className={`${styles.description} ql-editor`}
          dangerouslySetInnerHTML={{ __html: fullDescription }}
        />
      </div>
      {fullDescription?.length > 500 && (
        <div
          className={`flex w-full items-center justify-end bg-gradient-to-b from-white/0 to-white py-2 pb-5 text-blue`}
        >
          <span
            onClick={() => setMoreDeta((prev) => !prev)}
            className="cursor-pointer"
          >
            {moreDeta ? "بستن" : "توضیحات بیشتر"}
          </span>
          <ArrowBottom
            className={`${
              moreDeta ? "rotate-180" : "rotate-0"
            } mr-3 cursor-pointer fill-blue font-bold transition-all`}
          />
        </div>
      )}
    </div>
  );
};

export default Description;
